<script setup lang="ts">
withDefaults(
  defineProps<{
    size?: '32' | '40' | '36' | 'auto'
    backgroundClass?: string
  }>(),
  {
    size: '32',
  },
)
</script>
<template>
  <button
    class="flex items-center justify-center cursor-pointer overflow-visible [corner-shape:squircle] rounded-[34%]"
    :class="[
      {
        'w-7.5 h-7.5': size === '32',
        'w-8.5 h-8.5': size === '36',
        'w-9.5 h-9.5': size === '40',
      },
      backgroundClass ? backgroundClass : 'bg-transparent-background',
    ]"
  >
    <span class="relative flex items-center justify-center">
      <slot />
    </span>
  </button>
</template>
